import { render } from "./baseLeft.vue?vue&type=template&id=8a2796d4&scoped=true&ts=true"
import script from "./baseLeft.vue?vue&type=script&lang=ts"
export * from "./baseLeft.vue?vue&type=script&lang=ts"

import "./baseLeft.vue?vue&type=style&index=0&id=8a2796d4&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2796d4"]])

export default __exports__